import { authRequest } from "~/utils/api";
import { showAppMessage } from "~/redux/actions/app";

export const SET_FREE_POST_APPLICATION_DATA = "SET_FREE_POST_APPLICATION_DATA";
export const applications = ({ token, page = 1, per_page = 10, status }) => {
  return (dispatch) => {
    const params = { page, per_page };
    if (status) {
      params.status = status;
    }

    return authRequest(token, {
      method: "GET",
      url: `/job_applications/my_applications`,
      params,
    })
      .then((res) => {
        dispatch({
          type: SET_FREE_POST_APPLICATION_DATA,
          applicationData: res.data,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
        throw err;
      });
  };
};

export const SET_FREE_POST_STATUS_HISTORY = "SET_FREE_POST_STATUS_HISTORY";
export const statusHistory = ({ token, application_id }) => {
  return (dispatch) => {
    authRequest(token, {
      method: "GET",
      url: `/job_applications/${application_id}/status_history`,
    })
      .then((res) => {
        dispatch({
          type: SET_FREE_POST_STATUS_HISTORY,
          statusHistoryData: res.data.status_histories,
        });
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const CLEAR_FREE_POST_STATUS_HISTORY = "CLEAR_FREE_POST_STATUS_HISTORY";
export const clearStatusHistory = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_FREE_POST_STATUS_HISTORY });
  };
};

export const withdraw = ({ token, application_id, reason = null, cb }) => {
  return (dispatch) => {
    authRequest(token, {
      method: "POST",
      url: `/job_applications/${application_id}/withdraw`,
      data: { reason },
    })
      .then(() => {
        dispatch(showAppMessage("申请已撤回", "success"));
        cb && cb();
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};
